import {SectionSettingsModeEnum} from "@/scripts/sections/sectionSettings/sectionSettingsMode.js";

export default {
    sidebarState(state) {
        return state.sidePanelSettings;
    },
    sectionSettingsDocked(state) {
        return state.sectionSettingsMode === SectionSettingsModeEnum.DOCKED;
    },
    // The docked section settings live on the right and give way while a Design / Settings / Pages panel is open on the left.
    dockedSectionSettingsVisible(state, getters) {
        return getters.sectionSettingsDocked && !state.showSidePanel && !state.blockedEditor;
    },
    // A Design / Settings / Pages panel occupies the left rail; the canvas makes room on the left.
    editorLeftPanelOpen(state) {
        return !!state.showSidePanel;
    },
    // The docked section settings occupy the right rail; the page is scaled down at its full width to fit beside them.
    editorRightPanelOpen(state, getters) {
        return getters.dockedSectionSettingsVisible;
    },
    // The canvas is narrower on either side, so width-dependent components re-measure.
    editorSidePanelOpen(state, getters) {
        return getters.editorLeftPanelOpen || getters.editorRightPanelOpen;
    }
}
